const appBarLabels = {
  "app.bar.latest": "Feed",
  "app.bar.progress": "Progress",
  "app.bar.leaderboard": "Board",
  "app.bar.challenges": "Challenges",
  "app.bar.team": "Team",
  "app.bar.activity": "Activity",
  "app.bar.settings": "Settings",
};

export const appBar = {
  ...appBarLabels,
};
